module.exports = __webpack_public_path__ + "media/A0104.00b80472.mp4";